<template>
  <v-dialog :value="value" width="800" persistent>
    <v-card class="pa-8">
      <v-row align="center" justify="center" dense>
        <v-avatar class="mr-6" size="125">
          <v-img :src="$auth.user.picture" />
        </v-avatar>
        <v-col>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Name</v-list-item-subtitle>
              <v-list-item-title class="text-body-2 font-weight-medium">{{$auth.user.name}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Roles</v-list-item-subtitle>
              <v-list-item-title class="text-body-2 font-weight-medium" v-for="(role, index) in roles" :key="index">
                {{role}}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Email</v-list-item-subtitle>
              <v-list-item-title class="text-body-2 font-weight-medium">{{$auth.user.email}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Vendor Numbers</v-list-item-subtitle>
              <v-list-item-title class="text-body-2 font-weight-medium">
                <span>{{vendorNumbers.length > 0 ? vendorNumbers : 'All Vendors'}}</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
      <v-row>
        <v-spacer/>
        <v-btn outlined text rounded class="text-capitalize text-body-2" @click="$emit('update:value', false)">close</v-btn>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'UserProfile',

  props: {
    value: Boolean
  },

  computed: {
    isBuyer () {
      return this.$auth.isBuyer
    },

    roles () {
      return this.$auth.roles
    },

    vendorNumbers () {
      return this.$auth.vendorNumbers.join(', ')
    }
  }
}
</script>
